import React from 'react';
import PageHelp from './PageHelp';

const WorkspacePageHeader = ({ title, subtitle, actions, help }) => (
  <header className="ws-page-header">
    <div className="ws-page-header__main">
      <div className="ws-page-header__titleline">
        <h1 className="ws-page-header__title">{title}</h1>
        {help ? <PageHelp topic={help} /> : null}
      </div>
      {subtitle ? <p className="ws-page-header__subtitle">{subtitle}</p> : null}
    </div>
    {actions ? <div className="ws-page-header__actions">{actions}</div> : null}
  </header>
);

export default WorkspacePageHeader;
